module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/crm/kcc/consumer/consumer.component.css
// module id = ./src/app/crm/kcc/consumer/consumer.component.css
// module chunks = main